import { Component } from '@angular/core';
import { ResearchMemberItemStateEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Member Item States') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-researchmemberitemstate-form',
    templateUrl: './researchmemberitemstate.form.component.html'
})
export class ResearchMemberItemStateFormComponent extends BaseFormComponent {
    public record!: ResearchMemberItemStateEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

